import { createContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const RouterContext = createContext({ to: "", from: "" });

export const RouterContextProvider = ({ children }) => {
  const location = useLocation();

  const getInitialRoute = () => {
    const storedRoute = sessionStorage.getItem("lastRoute");
    if (storedRoute) {
      let from = JSON.parse(storedRoute);
      if (from) return from;
    }
    return {};
  };

  const [route, setRoute] = useState({
    to: location.pathname,
    toSearch: location.search,
    from: getInitialRoute()?.from,
    fromSearch: getInitialRoute()?.fromSearch,
  });

  useEffect(() => {
    setRoute((prev) => ({
      to: location.pathname,
      toSearch: location.search,
      from: prev.to !== location?.pathname ? prev?.to : route?.from,
      fromSearch: route?.fromSearch,
    }));
  }, [location]);

  useEffect(() => {
    sessionStorage.setItem(
      "lastRoute",
      JSON.stringify({ from: route?.from, fromSearch: route?.fromSearch } ?? "")
    );
  }, [route]);

  return (
    <RouterContext.Provider value={route}>{children}</RouterContext.Provider>
  );
};
